<template>
    <div style="height: 100vh;">
        <div style="">
            <a-card title="" style="border-radius: 20px;" :bordered="false">
                <div class="actions">

                    <p style="margin-left: 10px; margin-top: 3px; font-size: 15px; color: #05004E">Create Account</p>

                    <div style="display:flex; justify-content: space-around;">
                        <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                        Replenish Low Stock
                        <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                        </a-button> -->


                        <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->

                        <a-button style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;">
                            Send Email
                        </a-button>

                        <a-button style="border-raduis:6px; background: #fff;color:#0F3659">
                            Edit
                        </a-button>
                    </div>
                </div>

                <div style="margin-top: 30px; margin-bottom: 30px;">
                    <div>
                        <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: #9197B3;">
                                Account Image
                            </p>
                            <div class="clearfix mt-3">
                                <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    list-type="picture-card" :file-list="fileList" :beforeUpload="beforeUpload"
                                    @preview="handlePreview" @change="handleChange" class="upload">
                                    <div>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">
                                            Upload
                                        </div>
                                    </div>
                                </a-upload>
                                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                    <img alt="example" style="width: 100%" :src="previewImage" />
                                    <!-- <check-box :value="selectedValue" :msg="msg" @change="changeValue" :file="fileSelected"></check-box> -->
                                    <h4 style="display:flex;justify-content: center;margin-top:15px">Image Name: <span
                                            style="margin-left:10px">{{fileSelected.name}}</span></h4>
                                    <div style="display:flex;justify-content: center;">
                                    </div>
                                </a-modal>
                            </div>
                        </div>
                        <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                Account Information
                            </p>

                            <div>
                                <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
                                    <a-row>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item ref="name" label="Account Owner" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Peter Awin
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Account Name" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Account Site" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Parent Account" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Account Number" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Account Type" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        None
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Industry" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        None
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Annual Revenue" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Ksh
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Email Opt Out" prop="name">
                                                <a-switch />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item ref="name" label="Phone Number" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Website" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Ownership Type" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Peter Awin
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Employees" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>

                                </a-form-model>
                            </div>
                        </div>
                        <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                Address Information
                            </p>

                            <div>
                                <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
                                    <a-row>
                                        <a-col :span="8">
                                            <a-form-model-item ref="name" label="Street" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Town" prop="name">
                                                <a-input />
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Sub Region" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Tumu
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Region" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Northern
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item ref="name" label="Country" prop="name">
                                                <a-select placeholder="">
                                                    <a-select-option value="0">
                                                        Ghana
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </a-form-model>
                            </div>
                        </div>
                        <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                Description Information
                            </p>

                            <div>
                                <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 14 }">
                                    <a-form-model-item ref="name" label="Description" prop="name">
                                        <a-textarea placeholder="Enter description...."
                                            :auto-size="{ minRows: 3, maxRows: 6 }" />
                                    </a-form-model-item>
                                </a-form-model>
                            </div>
                        </div>

                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default {
    name: 'AddCustomer',
    components: {

    },
    data() {
        return {
            current: 0,
            activeKey: ['0'],
            showProductCategoryTab: false,
            showProductTab: true,
            showProductImageTab: true,
            showInventoryTab: true,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            imgSelected: false,
            fileSelected: {},
            selectedValue: "",
            newFilelist: [],
            labelCol: { span: 8 },
            wrapperCol: { span: 15 },
        };
    },
    computed: {
        ...mapGetters(['getStepCount'])
    },
    methods: {
        ...mapActions(['setStepCount', 'setProductGroupInfo', 'setProductDetailsInfo']),
        // onChange(current) {
        //     // console.log('onChange:', current);
        //     this.current = current;
        //     if(current === 0){
        //         this.setStepCount(0)
        //         this.$router.push(`/new-product`).catch(()=>{});
        //     }else if(current === 1){
        //         this.setStepCount(1)
        //         this.$router.push(`/product-details`).catch(()=>{});
        //     }
        //     else if(current === 2){
        //         this.setStepCount(2)
        //         this.$router.push(`/product-image`).catch(()=>{});
        //     }else if(current === 3){
        //         this.setStepCount(3)
        //         this.$router.push(`/inventory-details`).catch(()=>{});
        //     }
        // },

        redirectUrl() {
            this.$router.push(`/customers`).catch(() => { });
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.fileSelected = file
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },

    },
    created() {
        this.$watch(
            () => this.$store.getters.getStepCount,
            (newValue) => {
                if (newValue) {
                    this.current = this.getStepCount
                    if (this.current === 0) {
                        this.setStepCount(0)
                        this.activeKey = ['0'];
                        this.showProductCategoryTab = false
                        this.showProductTab = true
                        this.showProductImageTab = true
                        this.showInventoryTab = true
                    } else if (this.current === 1) {
                        this.setStepCount(1)
                        this.activeKey = ['1'];
                        this.showProductCategoryTab = true
                        this.showProductTab = false
                        this.showProductImageTab = true
                        this.showInventoryTab = true
                    }
                    else if (this.current === 2) {
                        this.setStepCount(2)
                        this.activeKey = ['2'];
                        this.showProductCategoryTab = true
                        this.showProductTab = true
                        this.showProductImageTab = false
                        this.showInventoryTab = true
                    } else if (this.current === 3) {
                        this.setStepCount(3)
                        this.activeKey = ['3'];
                        this.showProductCategoryTab = true
                        this.showProductTab = true
                        this.showProductImageTab = true
                        this.showInventoryTab = false
                    }
                }
            }
        );
    },
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.img_size {
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.descInputText {
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}

.dropdownItem {
    width: 336px;
    border-radius: 5px;
}

.selecInput {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}

.ant-layout-sider {
    background: #FFFFFF;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    background: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    border-color: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon:hover {
    color: #418a49;
}

.slider>>>.anticon {
    vertical-align: 2px;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #418a49;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon {
    color: #418a49;
}

.slider>>>.ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
    background-color: #418a49;
}

.slider {
    flex: none !important;
    max-width: none !important;
    min-width: none !important;
    width: 250px !important;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.upload-list-inline>>>.ant-upload-list-item {
    float: left;
    width: 200px;
    margin-right: 8px;
}

.upload-list-inline>>>.ant-upload-animate-enter {
    animation-name: uploadAnimateInlineIn;
}

.upload-list-inline>>>.ant-upload-animate-leave {
    animation-name: uploadAnimateInlineOut;
}

.ant-collapse-borderless {
    background-color: #fff;
    border: 0;
}
</style>

